import { tzOffsetMinutes } from "@/lib/timezone";

export const SOON_MS = 15 * 60 * 1000;
export const DURATIONS = [15, 30, 45, 60, 90, 120, 180];

export function formatWhen(iso, tz) {
  return new Date(iso).toLocaleString("en-US", {
    timeZone: tz, weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
}

export function formatTime(iso, tz) {
  return new Date(iso).toLocaleString("en-US", { timeZone: tz, hour: "numeric", minute: "2-digit" });
}

// Wall-clock date ("YYYY-MM-DD") + time ("HH:MM") in `tz` → UTC ISO string (two passes for DST edges).
export function wallToISO(dateStr, timeStr, tz) {
  const [y, mo, d] = dateStr.split("-").map(Number);
  const [h, mi] = timeStr.split(":").map(Number);
  const guess = Date.UTC(y, mo - 1, d, h, mi);
  let ts = guess - tzOffsetMinutes(new Date(guess), tz) * 60000;
  ts = guess - tzOffsetMinutes(new Date(ts), tz) * 60000;
  return new Date(ts).toISOString();
}

export function isoToWall(iso, tz) {
  const p = {};
  new Intl.DateTimeFormat("en-US", {
    timeZone: tz, hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
  }).formatToParts(new Date(iso)).forEach((x) => { if (x.type !== "literal") p[x.type] = x.value; });
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${String(parseInt(p.hour, 10) % 24).padStart(2, "0")}:${p.minute}` };
}

export function phaseOf(m, now) {
  if (m.status === "canceled") return "canceled";
  const s = new Date(m.start_at).getTime();
  if (now >= new Date(m.end_at).getTime()) return "ended";
  if (now >= s) return "live";
  return s - now <= SOON_MS ? "soon" : "upcoming";
}

export function countdown(iso, now) {
  const mins = Math.max(0, Math.round((new Date(iso).getTime() - now) / 60000));
  const d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
  if (d) return `in ${d}d ${h}h`;
  if (h) return `in ${h}h ${m}m`;
  return mins <= 0 ? "now" : `in ${m}m`;
}
